import React, { Component } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';

class TimeSeriesChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selected: false,
    };
    this.createInputArr();
  }

  createInputArr() {
      const monthArr = this.props.monthInfo.monthPriceArr;
      const fullArr = monthArr.map((monthData) => {
          const monthDate = reformatDateToDisplay(monthData.monthDate); // MM/YYYY
      const [month, year] = monthDate.split('/');
      return {
        time: monthDate,
        value: +monthData.unitPrice,
        month,
        year,
      };
    });
        /*    note that time can be a month name (as below) or a month value such a MM/YYYY
            this.inputArr =[{ time: 'Jan', value: 10 },
                              { time: 'Feb', value: 15 },
                              { time: 'Nov', value: 18 },
                              { time: 'Dec', value: 14 },
                          ];
          */
  
  // Compute interval
  const interval = fullArr.length > 24 ? 1 : 0;
  this.tickInterval = interval;

  // Only mark the first visible month of each year to show the year label
  let lastYear = null;
  this.inputArr = fullArr.map((entry, idx) => {
      const isVisible = interval === 0 || idx % (interval + 1) === 0; // match Recharts interval logic
      const showYear = isVisible && entry.year !== lastYear;
      if (showYear) lastYear = entry.year;

    return {
      ...entry,
      showYear,
    };
   });
}


  render() {
  //const tickInterval = this.inputArr.length > 24 ? 1 : 0; // every other month if > 24 months

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={this.inputArr}>
        <CartesianGrid stroke="#ccc" />
        <XAxis
            dataKey="time"
            interval={this.tickInterval}
            tick={(tickProps) => {
              const fullTick = this.inputArr.find(d => d.time === tickProps.payload.value);
              return (
                <CustomizedXAxisTick
                  {...tickProps}
                  month={fullTick?.month}
                  year={fullTick?.year}
                  showYear={fullTick?.showYear}
                  yearSpan={this.props.yearSpan}
                />
              );
            }}
          />
        <YAxis />
        <Tooltip />
        <Line type="monotone" dataKey="value" stroke="#8884d8" />
        {this.props.buyDates.map((markDate) => (
          <ReferenceLine
            key={markDate}
            x={markDate}
            stroke="red"
            label="↑ Purchase"
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
}
const CustomizedXAxisTick = ({ x, y, month, year, showYear, yearSpan }) => {
  const monthLabel = new Date(`${month}/01/${year}`).toLocaleString('default', { month: 'short' });
  const primaryLabel = yearSpan > 5 ? (showYear ? year : '') : monthLabel;
  const secondaryLabel = showYear && yearSpan <= 5 ? year : null;

  return (
    <g transform={`translate(${x},${y})`}>
      {primaryLabel && (
        <text x={0} y={0} dy={12} textAnchor="middle" fontSize={12} fill="#333">
          {primaryLabel}
        </text>
      )}
      {secondaryLabel && (
        <text x={0} y={0} dy={25} textAnchor="middle" fontSize={10} fill="#666">
          {secondaryLabel}
        </text>
      )}
    </g>
  );
};



export default TimeSeriesChart;
